// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U-TK","right":"styles_right__3Oewu"};